<div id="paymentSection" [ngClass]="paymentSectionExpanded ? 'aiBoxTwo' : 'aiBoxOne'" [hidden]="paymentSectionHidden">
    <span class="pTittle">{{ cargoPaymentInfo?.operationMode === 'Cash' && this.currentNextClick ? 'Payment' : 'Payment method' }}
        <button type="button" class="iconInfo" (click)="onShowPaymentInfo()" aria-label="Payment method information">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 9.25C12.3797 9.25 12.6935 9.53215 12.7432 9.89823L12.75 10V16.25C12.75 16.6642 12.4142 17 12 17C11.6203 17 11.3065 16.7178 11.2568 16.3518L11.25 16.25V10C11.25 9.58579 11.5858 9.25 12 9.25ZM12 7C12.4142 7 12.75 7.33579 12.75 7.75C12.75 8.16421 12.4142 8.5 12 8.5C11.5858 8.5 11.25 8.16421 11.25 7.75C11.25 7.33579 11.5858 7 12 7Z"
                fill="#6D6F73" />
        </svg>
        </button>
    </span>
    <div class="messageBox" *ngIf="(currentBluefinError && currentPaymentType !=='Manual Payment') || isCustomTimeoutError; else elseCustomErrorBlock">
        <div class="customErrorIcon"></div>
        <span class="spanText">An error occurred. Please try again to complete the transaction.</span>
    </div>
    <ng-template #elseCustomErrorBlock>
        <div class="messageBox"
            *ngIf="(currentMobyDeviceError || currentErrorCreditCard) && !currentSuccessfulPayment && !currentCashPayment && !currentCanceledByUser && !currentSubmitBluefin else elseBlock">
            <div class="customErrorIcon"></div>
            <span class="spanText">{{currentErrorMessage}}</span>
        </div>
    </ng-template>
    <ng-template #elseBlock>
        <div
            *ngIf="(!currentMobyDeviceError && !currentErrorCreditCard && !currentSuccessfulPayment && !currentCashPayment && !currentCanceledByUser && currentNextClick) || (currentSubmitBluefin && !currentSuccessfulPayment); else elseSuccessfulPayment ">
            <span class="sTitle">Payment in progress...</span>
        </div>
    </ng-template>
    <ng-template #elseSuccessfulPayment>
        <div class="messageBox"
            *ngIf="!currentMobyDeviceError && !currentErrorCreditCard && currentSuccessfulPayment && !currentCashPayment && !currentCanceledByUser && !currentSubmitBluefin; else elseCancel">
            <div class="customSuccessfulIcon"></div>
            <span class="spanText"> {{currentPaymentMessage}} successfully charged. <b>Auth code -
                    {{currentAuthCode}}</b></span>
        </div>
    </ng-template>
    <ng-template #elseCancel>
        <div class="messageBox"
            *ngIf="!currentMobyDeviceError && !currentErrorCreditCard && !currentSuccessfulPayment && !currentCashPayment && currentCanceledByUser; else elseCashPayment">
            <div class="customErrorIcon"></div>
            <span class="spanText"> {{currentPaymentMessage}} transaction canceled.</span>
        </div>
    </ng-template>
<ng-template #elseCashPayment>
  @if (currentNextClick) {
    <div class="messageBox">
      <alaska-checkbox
        label="I acknowledge the receipt of the total payable amount in cash."
        name="checkboxDemo"
        id="checkbox1"
        value="false"
        unchecked
        [error]="undefined"
        [disabled]="undefined"
        (input)="onCashChange($event)">
      </alaska-checkbox>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="elsePaymentType"></ng-container>
  }
</ng-template>

<ng-template #elsePaymentType>
  <span class="sTitle">Select the method in which the payment will be completed.</span>

  <div class="radioGroup">
    <input
      (change)="onPaymentSelected($event)"
      [disabled]="isNoSignatureNoPaymentScenario && currentPaymentType === 'Customer Payment'"
      type="radio"
      name="paymentRadio"
      id="manual"
      value="MP"
      [checked]="currentPaymentType === 'Manual Payment'">

    <label
      for="manual"
      [ngClass]="isNoSignatureNoPaymentScenario && currentPaymentType === 'Customer Payment'
        ? 'customDisabled'
        : 'customEnabled'">
      Agent Manual Payment
    </label>

    <input
      (change)="onPaymentSelected($event)"
      [disabled]="isNoSignatureNoPaymentScenario && currentPaymentType === 'Manual Payment'"
      type="radio"
      name="paymentRadio"
      id="customer"
      value="CP"
      [checked]="currentPaymentType === 'Customer Payment'">

    <label
      for="customer"
      [ngClass]="isNoSignatureNoPaymentScenario && currentPaymentType === 'Manual Payment'
        ? 'customDisabled'
        : 'customEnabled'">
      Customer Payment
    </label>
  </div>
</ng-template>
</div>    